import React, { type ReactNode } from 'react';

import { Content, Item, Label, List } from './FilterStack.style.ts';

export interface FilterStackProps {
    children: ReactNode;
}

export interface FilterStackItemProps {
    label?: string;
    children: ReactNode;
}

export function FilterStack({ children }: FilterStackProps) {
    return <List>{children}</List>;
}

function StackItem({ label, children }: FilterStackItemProps) {
    const labelMarkup = label?.length ? <Label>{label}</Label> : null;

    return (
        <Item>
            {labelMarkup}
            <Content>{children}</Content>
        </Item>
    );
}

FilterStack.Item = StackItem;
